



  import * as own0 from "ember-source/ember/index.js";

export default Object.assign({},
  {
      "ember/index": own0,
  }
);
